import allowedClientEnvVars from '../constants/allowedClientEnvVars'

/**
 * A helpful funciton to decide the current env, ie production/development
 * @return {Boolean} true/false
 */

export const isProductionNodeEnv = () => {
  return process.env.NODE_ENV === 'production'
}

export const isProduction = () => {
  return process.env.APP_ENV === 'production'
}

export const isStaging = () => {
  return process.env.APP_ENV === 'staging'
}

export const isDevelopment = () => {
  return process.env.APP_ENV === 'development'
}

export const isTest = () => {
  return process.env.APP_ENV === 'test' || isE2ETest()
}

export const isE2ETest = () => {
  return !!process.env.E2E_TEST
}

export const hasWindow = () => {
  return typeof window !== 'undefined'
}

export const getAllowedClientEnvVars = (
  envVars: Record<string, string | undefined>
) =>
  Object.fromEntries(
    Object.entries(envVars).filter(([key]) =>
      allowedClientEnvVars.includes(key)
    )
  )
